var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficulty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M7,9.5,8.5,11,11,7.5M15,9a2.5,2.5,0,0,1-1.062,2.045,2.5,2.5,0,0,1-2.893,2.893,2.5,2.5,0,0,1-4.091,0,2.5,2.5,0,0,1-2.893-2.893,2.5,2.5,0,0,1,0-4.091A2.5,2.5,0,0,1,6.955,4.062a2.5,2.5,0,0,1,4.091,0,2.5,2.5,0,0,1,2.893,2.893A2.5,2.5,0,0,1,15,9Z",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficulty);
export default __webpack_public_path__ + "static/media/difficulty.45ae01d03c146c20214ded71ce5eb6e2.svg";
export { ForwardRef as ReactComponent };